import type { User } from '@privy-io/react-auth';

import { WalletMfaMethod } from './wallet-mfa-types';

export const hasMfaMethod = (user: User | null, method: WalletMfaMethod): boolean =>
  user?.mfaMethods.includes(method) ?? false;

export const requireConfirmedState = (confirmed: boolean): void => {
  if (!confirmed) throw new Error('Privy user state did not confirm the wallet MFA change.');
};
